<template>
  <div class="container container-cozy">
    <div class="row">
      <div class="col-12 col-lg-12">
        <header class="mb-5 text-center">
          <h2>Sua cotação nas principais seguradoras do mercado</h2>
          <p class="mb-0">
            Aguarde enquanto buscamos pelo melhor preço,<br />ou siga o
            preenchimento para ser notificado se alguma cotação chegar
          </p>
          <b-spinner class="mt-3" v-if="loading"></b-spinner>
        </header>
      </div>
    </div>

    <div v-if="alertMessage" class="col-12">
      <div class="alert-custom alert-danger-custom">{{ alertMessage }}</div>
    </div>

    <section id="section-resumo-cotacao">
      <div class="wrapper-cotacoes-seguradoras">
        <div
          :class="getInsurerRowClass(insurer) + ' card-seguradora'"
          v-for="(insurer, index) in insurersOrdered"
          :key="insurer.identifier"
        >
          <input
            type="radio"
            name="seguradora"
            v-model="insurerSelected"
            :value="insurer.identifier"
            :id="'radio-card-' + index"
            class="d-none-billet"
          />
          <label class="card-seguradora-body" :for="'radio-card-' + index">
            <div class="cell">
              <img v-if="insurer.icon" :src="insurer.icon" class="logo-seguradora" />
            </div>

            <div v-if="insurer.loading" class="m-auto">
              <b-spinner v-if="insurer.loading"></b-spinner>
            </div>

            <template v-else>
              <div
                class="cell flex-grow-1 justify"
                v-if="insurer.error && !insurer.loading"
              >
              {{ insurer.error }}
              </div>
              <div
                class="taxa mb-2 mb-lg-0 cell"
                v-if="!insurer.error & !insurer.loading"
              >
                <span class="label">Taxa</span>
                <strong>{{
                  insurer.tax ? formatPercentage(insurer.tax) : ""
                }}</strong>
              </div>
              <div
                class="limite mb-2 mb-lg-0 cell"
                v-if="!insurer.error & !insurer.loading"
              >
                <span class="label">Limite</span>
                {{
                  insurer.limit != 0
                    ? formatCurrency(insurer.limit)
                    : "Sob consulta"
                }}
              </div>
              <div
                class="preco mb-2 mb-lg-0 cell"
                v-if="!insurer.error & !insurer.loading"
              >
                <span class="label">Prêmio</span>
                <strong>{{
                  insurer.price ? formatCurrency(insurer.price) : ""
                }}</strong>
              </div>
              <div
                class="wrapper-botao mt-3 mt-lg-0 cell"
                v-if="!insurer.error & !insurer.loading"
              >
                <div class="botao text-uppercase font-12">
                  <i class="far fa-circle mr-1 unchecked"></i
                  ><i class="fa fa-check-circle checked mr-1"></i> Selecionar
                </div>
              </div>
            </template>
          </label>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-lg-12 mt-5">
          <!-- <a
            @click="back()"
            class="btn btn-outline-secondary btn-lg text-uppercase px-4 mr-2"
            ><i class="fa fa-angle-left mr-2"></i
            ><span class="d-none-billet d-md-inline-block"> Voltar</span></a
          > -->
          <button
            :disabled="checkDisableAdvance"
            @click="save()"
            class="btn btn-primary btn-lg text-uppercase px-4"
            data-toggle="modal"
            data-target="#modal-cnpj"
          >
            Emitir <i class="fa fa-angle-right ml-2"></i>
          </button>
          <span
            v-b-tooltip.hover
            :title="tooltipTitle"
            class="ml-2"
            v-if="checkDisableAdvance"
          >
            <i class="fas fa-exclamation-circle text-warning"></i>
          </span>
          <div
            v-if="isLoading"
            class="overlay-modal d-flex align-items-center justify-content-center"
          >
            <div>
              <div class="d-flex justify-content-center mb-2">
                <b-spinner label="Loading..."></b-spinner>
              </div>
              <div class="d-flex align-items-center">
                <strong class="text-dark">Estamos gerando sua minuta, por favor aguarde.</strong>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import rentalGuaranteeService from "@/services/rentalGuarantee";
import numericFormatterMixin from "@/mixins/numericFormatter";
import uiHelperMixin from "@/mixins/uiHelper";

export default {
  name: "RentalQuotationSummary",
  mixins: [numericFormatterMixin, uiHelperMixin],
  props: {
    renterQuotationId: {
      type: String,
    },
  },
  data: () => ({
    insurerSelected: null,
    loading: false,
    isLoading: false,
    insurers: [],
    dataForm: {
      status: 1,
    },
  }),
  created() {
    this.getSupportedInsurers();
  },
  computed: {
    infoTitle() {
      return "Para prosseguir, por favor escolha uma seguradora.";
    },
    tooltipTitle() {
      return "Para prosseguir, por favor escolha uma seguradora.";
    },
    checkDisableAdvance() {
      return !this.insurerSelected;
    },

    insurersOrdered() {
      return this.insurers.slice().sort(function (a, b) {
        if (a.error && b.error) {
          if (a.error > b.error) {
            return -1;
          }
          if (a.error < b.error) {
            return 1;
          }
          return 0;
        }

        if (!a.error && b.error) {
          return -1;
        }

        if (a.error && !b.error) {
          return 1;
        }

        if (!a.loading && b.loading) {
          return -1;
        }

        if (a.loading && !b.loading) {
          return 1;
        }

        return 0;
      });
    },
  },
  methods: {
    getSupportedInsurers() {
      this.loading = true;
      rentalGuaranteeService
        .getInsurers(this.renterQuotationId)
        .then((response) => {
          this.insurers = response.data.map((insurer) => ({
            ...insurer,
            loading: !insurer.block,
            error: insurer.block ? "Não foi possível obter a cotação" : null,
          }));
          this.requestInsurersQuotations();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    requestInsurersQuotations() {
      this.insurers
      .filter((insurer) => !insurer.block)
      .forEach((insurer) => {
        this.getInsurerQuotation(insurer.identifier, insurer.url);
      });
    },
    getInsurerQuotation(insurerIdentifier, insurerQuotationUrl) {
      const insurerIndex = this.insurers.findIndex(
        (insurer) => insurer.identifier == insurerIdentifier
      );
      rentalGuaranteeService
        .getInsurerQuotation(insurerQuotationUrl)
        .then((response) => {
          this.$set(this.insurers, insurerIndex, {
            ...this.insurers[insurerIndex],
            ...response.data,
          });
        })
        .catch((error) => {
          this.$set(this.insurers, insurerIndex, {
            ...this.insurers[insurerIndex],
            error: error.response && error.response.status == 404 ?
              "Integração não disponível" :
              "Não foi possível obter a cotação",
          });
        })
        .finally(() => {
          this.$set(this.insurers, insurerIndex, {
            ...this.insurers[insurerIndex],
            loading: false,
          });
        });
    },
    getInsurerRowClass(insurer) {
      return !insurer.loading && !insurer.error ? "disponivel" : "indisponivel";
    },
    back() {
      this.$router.push({
        name: "term-contract",
        params: { renterQuotationId: this.renterQuotationId },
      });
    },
    save() {
      if (!this.insurerSelected) {
        this.showError("Por favor, selecione uma seguradora para prosseguir.");
        return;
      }

      this.isLoading = true;
      
      // 1. Primeiro atualiza o insurer_selected
      rentalGuaranteeService
        .updateInsurerSelected(this.renterQuotationId, this.insurerSelected)
        .then((response) => {
          if (response.status != 200) {
            this.showError(response.data.message);
            return;
          }
          
          // 2. Depois chama apenas o conclusionQuotation (que já faz issue + conclusion)
          return rentalGuaranteeService.conclusionQuotation(this.renterQuotationId);
        })
        .then((response) => {
          if (response && response.status != 200 && response.status != 202) {
            this.showError(response.data.message);
            return;
          }
          this.nextStep();
        })
        .catch(() => {
          this.showError("Não foi possível emitir a cotação com esta seguradora.");
          this.scroll();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    nextStep() {
      this.$router.push({
        name: "final-renter-guarantee-quotation",
        params: { renterQuotationId: this.renterQuotationId },
      });
    },
  },
};
</script>

<style>

</style>
